import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import StarterPlanDetailsCard from 'components/StarterPlanDetailsCard';
import MemberPlanDetailsCard from 'components/MemberPlanDetailsCard';
import OwnerPlanDetailsCard from 'components/OwnerPlanDetailsCard';
import { UserTypeEnum } from 'enums';
import LoadingCircle from 'components/LoadingCircle';
import { useAuthUser } from 'features/auth/AuthUserContext';
import JournalPlanDetails from 'components/JournalPlanDetails';

const Props = {
  changePlanAction: PropTypes.bool,
  paymentMethodUpdate: PropTypes.bool,
};

export default function PlanDetailsCard({ changePlanAction, paymentMethodUpdate }) {
  const { user } = useAuthUser();
  const isLabResearcherMember = user.team !== 1 && user.tp_user !== UserTypeEnum.LAB_RESEARCHER;
  const isJournalMember = user.tp_user === UserTypeEnum.JOURNAL;
  const [userHasPaidPlan, setUserHasPaidPlan] = useState(false);
  const [isLoadingUserData, setIsLoadingUserData] = useState(true);

  useEffect(() => {
    if (user.tp_user) {
      setUserHasPaidPlan(user.tp_user !== 'T');
    }

    setIsLoadingUserData(false);
  }, [user.tp_user]);

  if (isLoadingUserData) {
    return <LoadingCircle sizeProps={40} />;
  }

  if (isJournalMember) {
    return <JournalPlanDetails />;
  }

  if (isLabResearcherMember) {
    return <MemberPlanDetailsCard />;
  }

  if (userHasPaidPlan) {
    return (
      <OwnerPlanDetailsCard
        user={user}
        changePlanAction={changePlanAction}
        paymentMethodUpdate={paymentMethodUpdate}
      />
    );
  }

  return <StarterPlanDetailsCard />;
}

PlanDetailsCard.propTypes = Props;
